/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

/**
 * A directive for adding infinite scrolling to the window for a particular container.
 * If the browser window is scrolled within BUFFER of the bottom of the container,
 * the configured controller's getNextPage function is called.
 *
 * The scroll container must have the bulb-infinite-scroll-window attribute set to a controller.
 * This directive requires the controller to have the following:
 * - a function "getNextPage", which causes more content to be added to the container,
 *   and returns a promise that is resolved when the new content has been added,
 *   or if no more content is available.
 *   If the controller has no getNextPage function, window scrolling will have no effect on it.
 * - a boolean field "infiniteScrollWindowEnabled". The controller should initialize infiniteScrollWindowEnabled to true,
 *   and should set it to false once all the available content has been added.
 *   If the controller has no infiniteScrollWindowEnabled field, window scrolling will never be handled.
 *
 * Usage example:
 *     <div bulb-infinite-scroll-window="searchResultsCtrl">
 */
angular.module('bulbApp.utilsModule')

.directive('bulbInfiniteScrollWindow', ['$log','$window', bulbInfiniteScrollWindow]);

function bulbInfiniteScrollWindow($log, $window) {
  // Namespace the scroll event.
  var SCROLL_EVENT = 'scroll.infiniteScrollWindow';
  // When scrolled to within this many times the viewport height of the configured element's bottom, get more content.
  var BUFFER_VIEWPORTS = 1;

  return {
    restrict: 'A',
    link: function(scope, elem, attrs) {
      var jqWindow = jQuery($window);
      var ctrlName = attrs.bulbInfiniteScrollWindow;
      var ctrl = scope[ctrlName];
      var previousScrollY = 0;

      $log.debug('viewport height: ' + jqWindow.height() + ', ' +
        BUFFER_VIEWPORTS + ' * viewport height: ' + BUFFER_VIEWPORTS * jqWindow.height());

      // Private handler for the window scroll event.
      // Calls the controller's scroll handler function
      function scrollWindow(event) {
        // ignore scroll up
        if ($window.scrollY < previousScrollY) {
          jqWindow.one(SCROLL_EVENT, scrollWindow);
          return;
        }
        previousScrollY = $window.scrollY;
        var viewportBottom = $window.scrollY + jqWindow.height();
        var elementBottom = elem.offset().top + elem.height();
        if (elementBottom - viewportBottom < (BUFFER_VIEWPORTS * jqWindow.height())) {
          $log.debug('calling getNextPage: elem height: ' + elem.height() +
            ', remaining elem: ' + (elementBottom - viewportBottom));
          ctrl.getNextPage().then( function() {
            jqWindow.one(SCROLL_EVENT, scrollWindow);
          });
        } else {
          jqWindow.one(SCROLL_EVENT, scrollWindow);
        }
      }

      // When the element has scroll enabled, handle the window scroll event.
      // If no getNextPage function, don't bother.
      if (ctrl.getNextPage) {
        scope.$watch(ctrlName + '.infiniteScrollWindowEnabled', function (isScrollEnabled) {
          if (isScrollEnabled) {
            jqWindow.one(SCROLL_EVENT, scrollWindow);
          } else {
            jqWindow.off(SCROLL_EVENT);
          }
        });
      }
    }
  };
}
